import { Link } from "react-router-dom";
import { useContext } from "react";
import { CartContext } from "../context/CartContext";

export default function ProductCard({ product }) {
  const { addToCart } = useContext(CartContext);

  return (
    <div className="group bg-white dark:bg-background-dark/50 rounded-xl overflow-hidden border border-[#e7e3cf] dark:border-[#3d3a2a] hover:shadow-xl transition-all">
      <div className="relative h-48 overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-110"
          data-alt="Close up of ornate marigold garland"
          style={{
            backgroundImage: `url("${product.image || "https://via.placeholder.com/600"}")`,
          }}
        ></div>
        <div className="absolute top-3 left-3 flex gap-2">
          <span className="bg-white/90 dark:bg-background-dark/90 backdrop-blur px-2 py-1 rounded-md text-[10px] font-black uppercase tracking-widest flex items-center gap-1 text-green-600">
            <span className="material-symbols-outlined !text-xs">verified</span>
            Verified
          </span>
        </div>
        <button className="absolute top-3 right-3 p-2 bg-white/80 backdrop-blur rounded-full text-[#9a8d4c] hover:text-red-500 transition-colors">
          <span className="material-symbols-outlined text-sm">favorite</span>
        </button>
      </div>
      <div className="p-5">
        <div className="flex justify-between items-start mb-1">
          <h4 className="font-extrabold text-lg group-hover:text-primary transition-colors">
            {product.name}
          </h4>
          <div className="flex items-center gap-1 text-primary">
            <span className="material-symbols-outlined !text-sm">star</span>
            <span className="text-sm font-bold">{product.rating}</span>
          </div>
        </div>
        <p className="text-sm text-[#9a8d4c] font-medium mb-4">
          {product.description}
        </p>
        <div className="flex items-center gap-4 mb-6">
          <div className="flex items-center gap-1 text-xs text-[#9a8d4c]">
            <span className="material-symbols-outlined !text-sm">
              location_on
            </span>
            <span>{product.distance_km} km away</span>
          </div>
          <div className="flex items-center gap-1 text-xs text-[#9a8d4c]">
            <span className="material-symbols-outlined !text-sm">history</span>
            <span>{product.bookings} Bookings</span>
          </div>
        </div>
        <div className="flex items-center justify-between pt-4 border-t border-[#e7e3cf] dark:border-[#3d3a2a]">
          <div>
            <p className="text-[10px] text-[#9a8d4c] font-bold uppercase tracking-widest">
              Starting Price
            </p>
            <p className="text-xl font-black text-primary">
              ${product.starting_price}
            </p>
          </div>
          <Link
            to={`/product/${product.id}`}
            className="bg-primary text-background-dark px-4 py-2.5 rounded-lg font-bold text-sm hover:brightness-110 transition-all"
          >
            View Profile
          </Link>
        </div>
      </div>
    </div>
  );
}
